import React from "react";
import { motion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
import { Button } from "./Button";
import { LOGO_URL, MOTTO_LINES } from "../data/content";
export function Hero() {
  return <section id="inicio" className="bg-ink pt-20 text-paper" data-id="element-152" data-mp="9luzmm7107tq">
      <div className="mx-auto flex max-w-4xl flex-col items-center px-6 py-16 text-center lg:py-24" data-id="element-153" data-mp="4lyvmmybwge6">
        <motion.img src={LOGO_URL} alt="Escudo de Fortis Sports Management: un águila dorada con alas formadas por banderas del mundo" initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} style={{
        WebkitMaskImage: "radial-gradient(circle at center, #000 74%, transparent 100%)",
        maskImage: "radial-gradient(circle at center, #000 74%, transparent 100%)"
      }} className="aspect-square w-80 object-contain mix-blend-lighten sm:w-[26rem] lg:w-[30rem]" data-id="element-154" data-mp="1297a3xzwwp6o" />

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 flex flex-col items-center" data-id="element-155" data-mp="3j9tzsvxzjik8">
          <h1 className="max-w-4xl text-5xl font-semibold leading-[1.05] tracking-tight sm:text-6xl lg:text-7xl" data-id="element-156" data-mp="3e9fpt8ctpyjk">
            Representación integral para <span className="text-gold" data-id="element-157" data-mp="30h9blrt8e1mr">futbolistas</span>
          </h1>
          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-paper/75" data-id="element-158" data-mp="3599ik47pxusu">
            Acompañamos al jugador en contratos, oportunidades, bienestar e imagen profesional, con decisiones
            estratégicas en cada etapa de la carrera.
          </p>
          <div className="mt-10" data-id="element-159" data-mp="2vgu0z80c388h">
            <Button href="#contacto" data-id="element-160" data-mp="2hjf3dfzxfu5f">
              Hablar con Fortis
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-161" data-mp="2hlj8205ngx6r" />
            </Button>
          </div>

          <blockquote className="mt-16 flex flex-col items-center" data-id="element-162" data-mp="2lmlcqwic61g4">
            <span className="h-px w-16 bg-gold" aria-hidden="true" data-id="element-163" data-mp="s3mfk97g6b1j" />
            <p className="mt-6 text-base italic leading-relaxed text-paper/85 sm:text-lg" data-id="element-164" data-mp="nb1ohffxec1p">
              {MOTTO_LINES.map(line => <span key={line} className="block" data-id="element-165" data-mp="ichx2zikc81y">
                  {line}
                </span>)}
            </p>
          </blockquote>
        </motion.div>
      </div>
    </section>;
}